mutation BulkRemoveMetadataValue($libraryFilters: InputLibraryFilters!, $fieldId: ID!) {
    removeMetadata(libraryFilters: $libraryFilters, fieldId: $fieldId)
}
